import React, { FC } from 'react';
import Box, { BoxProps } from '@mui/material/Box';

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: number;
    boxSx?: BoxProps['sx'];
}

const TabPanel: FC<TabPanelProps> = (props) => {
    const { children, value, index, boxSx, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            style={{ padding: 2 }}
            {...other}
        >
            {value === index && <Box sx={{ p: 3, ...boxSx }}> {children}</Box>}
        </div>
    );
};

export default TabPanel;
